import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { formMockHtml } from "./form-mock-html";

export default {
    title: "Components/Webinar",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-webinar",
    args: {
        dark: false,
        headerTitle: "Header title",
        headerImage: "",
        withInfo: true,
        speakersTitle: "Speakers",
        date1: "2020-05-20 17:32:33",
        date2: "2020-05-21 17:32:33",
        dateFormat: "D.M.YYYY - H:mm",
        formTitle: "Register now",
    },
    argTypes: {
        dark: {
            control: { type: "boolean" },
        },
        headerTitle: {
            control: { type: "text" },
        },
        headerImage: {
            control: { type: "text" },
        },
        withInfo: {
            control: { type: "boolean" },
        },
        speakersTitle: {
            control: { type: "text" },
        },
        "date-1": {
            control: { type: "text" },
        },
        "date-2": {
            control: { type: "text" },
        },
        "date-format": {
            control: { type: "text" },
        },
    },
};

interface WebinarArgs {
    dark: boolean;
    headerTitle: string;
    headerImage: string;
    withInfo: boolean;
    speakersTitle: string;
    date1: string;
    date2: string;
    dateFormat: string;
    formTitle: string;
}

const Template = ({
    dark,
    headerImage,
    headerTitle,
    withInfo,
    speakersTitle,
    date1,
    date2,
    dateFormat,
    formTitle,
}: WebinarArgs) => {
    return html`
        <div class="ux-t-container-full">
            <ux-iws-webinar
                ?dark=${dark}
                header-title="${headerTitle}"
                header-image="${headerImage}"
                speakers-title="${speakersTitle}"
                webinar-data-uid="123456"
                date-1="${date1}"
                date-2="${date2}"
                date-format="${dateFormat}"
                form-title="${formTitle}"
            >
                <div slot="header-text">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. 👀
                    Reprehenderit, sequi laudantium id cum explicabo, quo
                    excepturi eligendi, autem mollitia minus saepe expedita
                    voluptatem officia veniam illo quos nobis officiis eum.
                </div>
                ${withInfo
                    ? html`
                          <ux-iws-webinar-info name="Date" slot="info">
                              <ux-date-time
                                  utc="${date1}"
                                  format="${dateFormat}"
                              ></ux-date-time
                              ><br />
                              <ux-date-time
                                  utc="${date2}"
                                  format="${dateFormat}"
                              ></ux-date-time>
                          </ux-iws-webinar-info>
                          <ux-iws-webinar-info name="Duration" slot="info">
                              4h
                          </ux-iws-webinar-info>
                          <ux-iws-webinar-info name="Price" slot="info">
                              free
                          </ux-iws-webinar-info>
                      `
                    : ""}
                <div slot="description">
                    <h2 class="ux-text-headline ux-text-headline--small">
                        Description
                    </h2>
                    <p>
                        Description text Lorem ipsum dolor sit amet consectetur
                        adipisicing elit. Laudantium, labore illum non quos
                        nihil ullam placeat fuga necessitatibus voluptas libero
                        incidunt similique. Repudiandae atque corporis sint iste
                        quas voluptates nostrum!
                    </p>
                </div>
                <div slot="form">
                    <ux-form async>${formMockHtml}</ux-form>
                </div>
                <ux-iws-webinar-speaker
                    name="Marie Curie"
                    designation="Nuclear Physicist"
                    image="./mock-assets/images/square-person.jpg"
                    slot="speaker"
                >
                    <p>Speaker 1 description</p>
                </ux-iws-webinar-speaker>
                <ux-iws-webinar-speaker
                    name="Albert Einstein"
                    designation="Laser Expert"
                    image="./mock-assets/images/square-person.jpg"
                    slot="speaker"
                >
                    <p>Speaker 2 description</p>
                </ux-iws-webinar-speaker>
                <ux-iws-webinar-speaker
                    name="Isaac Newton"
                    designation="Mathematician"
                    image="./mock-assets/images/square-person.jpg"
                    slot="speaker"
                >
                    <p>Speaker 3 description</p>
                </ux-iws-webinar-speaker>
            </ux-iws-webinar>
        </div>
    `;
};

const SuccessTemplate = () => {
    return html`
        <div>
            <h2 class="ux-text-headline ux-text-headline--big">
                Thank you for registering!
            </h2>
            <ux-iws-webinar-summary>
                <ux-iws-webinar-info name="Date">
                    Thursday, 28.02.2024 9:00 - 13:00 (MEZ) <br />
                    Friday, 29.02.2024 9:00 - 13:00 (MEZ)
                </ux-iws-webinar-info>
                <ux-iws-webinar-info name="Duration">4h</ux-iws-webinar-info>
            </ux-iws-webinar-summary>
            <p class="ux-text-body">
                You will receive an email confirmation shortly.
            </p>
            <ux-button
                href="calendar.icalevent.ics"
                target="_blank"
                rel="noopener"
                >Add to Calendar</ux-button
            >
        </div>
    `;
};

export const Default = Template.bind({});

export const Dark = Template.bind({});
Dark.args = {
    dark: true,
};

export const CustomImage = Template.bind({});
CustomImage.args = {
    headerImage: "./mock-assets/green-market-form/product-2.png",
};

export const DarkWithCustomImage = Template.bind({});
DarkWithCustomImage.args = {
    dark: true,
    headerImage: "./mock-assets/green-market-form/product-2.png",
};

export const WithoutInfo = Template.bind({});
WithoutInfo.args = {
    withInfo: false,
};

export const SingleDate = Template.bind({});
SingleDate.args = {
    date2: "",
};

export const FormSuccess = SuccessTemplate.bind({});
